import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询系统数字资产属性
export const queryDigitalAttrs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDigitalAttrs', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/v1/asset/digitalattr/pagelist', payload);
    commit('setDigitalAttrs', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setDigitalAttrs', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询系统数字资产属性详情
export const queryDigitalAttrDetail: IActionFn<IModuleState> = async ({ commit, state }, code) => {
  try {
    commit('setDigitalAttrDetail', { data: null, loading: true });
    const res = await $http.get(`/v1//asset/digitalattr/${code}/detail`);
    commit('setDigitalAttrDetail', { data: res });
  } catch (e) {
    commit('setDigitalAttrDetail', { data: null });
  }
};

// 查询系统数字资产属性变更日志
export const queryDigitalAttrLogs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const { code, ...rest } = payload;
    commit('setDigitalAttrLogs', { ...state.logs, loading: true });
    const res: IPageData = await $http.post(`/v1/asset/digitalattr/${code}/updatelog`, rest);
    commit('setDigitalAttrLogs', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setDigitalAttrLogs', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询系统数字资产属性类型
export const queryDigitalAttrTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setDigitalAttrTypes', { ...state.attrTypes, loading: true });
    const res = await $http.get('/common/chooseoptions/DigitalAssetAttributeType');
    commit('setDigitalAttrTypes', { data: res });
  } catch (e) {
    commit('setDigitalAttrTypes', { data: [] });
  }
};

// 检查数字资产属性编码是否可用
export const checkDigitalAttrExisted: IActionFn<IModuleState> = async ({ commit, state }, code) => {
  try {
    commit('setDigitalAttrExisted', { data: null, loading: true });
    const res = await $http.post('/v1/asset/digitalattr/codeexistence', { code });
    commit('setDigitalAttrExisted', { data: !res });  // 接口里true表示编码可用, store里true表示编码已存在,不可用
    return true;
  } catch (e) {
    commit('setDigitalAttrExisted', { data: false });
    return false;
  }
};

// 新增系统数字资产属性
export const addDigitalAttr: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/asset/digitalattr/add', payload);
    store.commit('common/setToast', { visible: true, text: '新增成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 修改系统数字资产属性
export const editDigitalAttr: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/asset/digitalattr/update', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除系统数字资产属性
export const deleteDigitalAttr: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/digitalattr/delete', payload);
    store.commit('common/setToast', { visible: true, text: '删除成功' });
  } finally {
    commit('setConfirm', { visible: false, loading: false });
  }
};

// 发布系统数字资产属性
export const publishDigitalAttr: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/digitalattr/publish', payload);
    store.commit('common/setToast', { visible: true, text: '发布成功' });
  } finally {
    commit('setConfirm', { visible: false, loading: false });
  }
};
